<app-dialog [buttons]="dialogButtons" header="Sobre seu cadastro" message="Informe seu celular para completar o cadastro.">
  <form [formGroup]="form">
    <bhvmat-formfield>
      <input type="text" appErrorMessage formControlName="phone_number_main" [textMask]="telMask" placeholder="(00) 0000-00000">
    </bhvmat-formfield>
  </form>
</app-dialog>
